
/* eslint-disable */
// Autogenerated
// -------------
// gulpfile.ts/wasm.ts --> generateBuildInfo

export const Build = {
    version: "0.73.4 (75ba991718455e71b643a068b675e327)",
    buildSeed: 1649932961642,
    "wdosbox.shared.wasm": {
        "size": 1489464,
        "gzSize": 506505
    },
    "wdosbox.shared.js": {
        "size": 143684,
        "gzSize": 36327
    },
    "wdosbox.wasm": {
        "size": 1469540,
        "gzSize": 502879
    },
    "wdosbox.js": {
        "size": 123957,
        "gzSize": 32338
    },
    "wlibzip.wasm": {
        "size": 112932,
        "gzSize": 54521
    },
    "wlibzip.js": {
        "size": 77034,
        "gzSize": 20087
    }
,
};
